import { Container } from 'inversify';
import 'reflect-metadata';

function initializeContainer() {
    return new Container({autoBindInjectable: true});
}

export {initializeContainer};
